<template>
	<div class="tip-wrap">
		{{tip}}
	</div>
</template>

<script>
	export default {
		props:{
			tip:String,
		},

		methods: {

		},
		mounted() {
			let _that = this;

		}
	};
</script>

<style scoped lang="less">
	.tip-wrap{
		position: absolute;
		z-index: 10;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		padding-left: 31px;
		padding-right: 31px;
		font-size: 12px;
		color: #f5f5f5;
		background-color: rgba(102, 102, 102, 0.8);
		height: 49px;
		line-height: 49px;
		border-radius: 3px;
		white-space: nowrap;
	}
</style>
